// extracted by mini-css-extract-plugin
export default {"divider":"CorsV3hZDdCPcTKDHYMI"};